<template>  
  <div class="ml-45 mr-44 Notification">  
    <div class="userprofil1 w100">
    	<div class="flex j-between pb-22 a-center" style="border-bottom: 1px solid #E1E1E1; box-sizing: border-box;">
    		<div class="tit-24 ys-33 B-400 userProfile-righttitle montserRegular">Notification</div>
    	</div>
    	<!-- <el-divider></el-divider> -->
    	<div class="userProfile-right-contrn pt-44">
    		<div class="flex flex-wrap mb-35 j-between a-center textlist" v-for="(l,i) in xiaoxi">
    			<div class="tit-16 tit1 B-300 a-center mr-60" style="color: #5E5E5E;width:60%">
					<span style="color: #c7c7c7;" class="iconfont icon-gonggao1 pr-7 tit-16"></span>
					<span>{{l.message}}</span>
				</div>
    			<div class="tit-16 titTime B-300 " style="color: #8C8C8C;">{{l.createTime}}</div>
    		</div>
    		
    	</div>
    </div> 
  </div>  
</template>  

<script>  
import {Notification} from '@/api/Personal.js';
export default {  
  data() {  
    return {  
		xiaoxi:[
		// 	{message:'Congrats, You got a new badge!',createTime:'2024-10-17 18:02'},
		// {message:'Congrats, You got a new badge!',createTime:'2024-10-17 18:02'},
		// {message:'Congrats, You got a new badge!',createTime:'2024-10-17 18:02'},
		// {message:'Congrats, You got a new badge!',createTime:'2024-10-17 18:02'},
		]
    };  
  }, 
   props: {
   	informations: {
   		type: [Object,Array],
   		default() {
		return { /* 默认对象或数组的内容 */ };
	  }
   	},
   },
  created() {
  	Notification({ "pageNum": 0,  "pageSize":10}).then(shu=>{
		this.xiaoxi=shu.data.content
	})
  },
  methods: {  
   
  }
};  
</script>  

<style lang="scss" scoped>  

	.textlist {}


// ==========================================================================================================================================================================
// 响应式 
@media screen and (max-width: 767px) {
	.textlist .tit1 {width: 100% !important;}
	.textlist .titTime {width: 100%;margin-top: .1rem;}

}
</style>